import styled from 'styled-components';

import {getColor, getRem, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const CheckboxContainer = styled(View)`
  align-items: center;
  column-gap: ${ms(8)};
  margin-block-start: ${ms(20)};
`;

export const CheckboxLabel = styled(Text)`
  font-size: ${getRem(14)};
  line-height: ${getRem(16)};
  color: ${getColor('text1')};
`;
